import React, { useEffect, useState } from 'react';
import './TempAbstractUpload.page.css';
import DocumentUploadForm from '../../ui/panels/Forms/DocumentUploadForm';
import UserTokenData from '../../types/UserTokenData';
import { UserUtils } from '../../utils/UserUtils';
import { useNavigate, useParams } from 'react-router-dom';
import { DocumentJobModel } from '../../types/DocumentJobModel';
import DocumentJobList from '../../ui/panels/DocumentJobList/DocumentJobList';
import LoadingSpinner from '../../ui/components/LoadingSpinner';
import AbstractUploadForm from '../../ui/panels/Forms/AbstractUploadForm';

function TempAbstractUploadPage(): JSX.Element {
  const entityId = 0;
  const [token, setToken] = useState<string>(
    localStorage.getItem('token') || ''
  );
  const nav = useNavigate();
  const [userDetails, setUserDetails] = useState<UserTokenData>({
    userName: '',
    id: '',
    email: '',
    role: '',
  });

  useEffect(() => {
    if (token == '') {
      nav('/signin');
      return;
    }
    const decodedDetails = UserUtils.decodeUserToken(token);
    if (!decodedDetails) {
      nav('/signin');
    } else {
      setUserDetails(decodedDetails);
    }
    if (isNaN(entityId) || !Number.isInteger(entityId)) {
      // Go to the previous page
      nav(-1);
    }
  }, []);

  // Write function to load currently uploaded documents

  return (
    <div className="CaseDocUploadPage">
      <div className="CaseDocRow">
        {userDetails.id == '' ? (
          <LoadingSpinner />
        ) : (
          <AbstractUploadForm
            token={token}
            userDetails={userDetails}
            entityId={entityId}
            nav={nav}
            onUploadSuccess={async () => {}}
          />
        )}
      </div>
    </div>
  );
}

export default TempAbstractUploadPage;
